import WebStorage, { storageAvailable } from '../shared/web-storage';

export { storageAvailable };

export const localStorage =
  storageAvailable('localStorage') || new WebStorage();
export const sessionStorage =
  storageAvailable('sessionStorage') || new WebStorage();

export default WebStorage;
